const BaseUrl = {
  mainBase: 'https://gulftic-system.fci.group/api/admin/',
  linkToEngineers: 'https://ce.gulftic.com/orders/order',
}

export default BaseUrl
